<template>
    <v-card class="pa-3" height="100%">
        <apexchart
            type="area"
            height="350"
            :options="chart.registration.options"
            :series="chart.registration.series"
        ></apexchart>
    </v-card>
</template>
<script>
  import { mapGetters } from "vuex";  
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts,
    },
  data: () => ({
      chart: {
        registration: {
          series: [], // Populated by API call
          options: {
            title: {
              text: "Registrations vs Active Dasher",
            },
            noData: {
              text: "No data available",
            },
            chart: {
              type: "area",
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            xaxis: {
              type: "datetime",
              categories: [],
            },
          },
        },
      }

    }),

    created() {
      // this.initialize();
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["registration"]);
        this.updateCharts();
      },

      async updateCharts() {  
        this.chart.registration.series = this.indexData.dasherReg_overview.series;
        this.chart.registration.options = {
          xaxis: {
            categories: this.indexData.dasherReg_overview.categories,
            type: "datetime",
          },
        };
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
    z-index: -1;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0;
  }
</style>